<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" headerClasses="pb-0" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500 text-center">Add Mortgage Application</h3>
        <b-form role="form" @submit.prevent="addProductApplication">
            <b-row>
                <b-col cols="12">
                    <b-form-group label="Bank">
                        <el-select v-model="form.bank_code" filterable placeholder="Select">
                            <el-option
                            v-for="bank in banks"
                            :key="bank.bank_code"
                            :label="bank.bank_name"
                            :value="bank.bank_code"
                            >
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group label="Types of Property Sales">
                        <el-select v-model="form.property_type" placeholder="Select">
                            <el-option
                                v-for="(type, index) in propertyOptions"
                                :key="index"
                                :label="type.label"
                                :value="type.value"
                            ></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="Project Name">
                        <b-form-input
                        v-model="form.project_name"
                        type="text"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="Unit No">
                        <b-form-input
                        v-model="form.unit_no"
                        type="text"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="SPA Amount">
                        <b-form-input
                        v-model="form.spa_price"
                        type="text"
                        step="0.01"
                        required
                    
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="Loan Margin (%)">
                        <b-form-input
                            v-model="form.loan_margin"
                            type="number"
                            step="0.01"
                        
                        ></b-form-input>
                        </b-form-group>
                    </b-col>

                <b-col cols="6">
                    <b-form-group label="Loan Amount">
                        <b-form-input
                        v-model="form.loan_amount"
                        type="text"
                        step="0.01"
                        required
                    
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group label="Interest (%)">
                        <b-form-input
                        v-model="form.interest"
                        type="number"
                        step="0.01"
                        required
                    
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group label="Tenure Year">
                        <b-form-input
                        v-model="form.tenure_years"
                        type="number"
                        step="0.01"
                        required
                    
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group label="Installment">
                        <b-form-input
                        v-model="form.installment"
                        type="number"
                        required
                        step="0.01"
                    
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                        <h3 class="mb-4">Arrangement Fee</h3>
                    </b-col>
    
                <b-col cols="12">
                    <b-form-group label="Arrangement Fee Amount">
                        <b-form-input
                        v-model="form.arrangement_fee"
                        type="number"
                        step="0.01"
                            ></b-form-input>
                    </b-form-group>
                </b-col>
                
                <b-col cols="12">
                    <b-form-group label="Arrangement Fee SST">
                        <b-form-radio-group
                            v-model="form.arrangement_fee_sst"
                            :options="SST_OPTIONS"
                    
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>

                <b-col cols="12" >
                    <b-form-group label="Total Arrangement Fee (RM)">
                        <b-form-input
                        v-model="form.arrangement_fee_amount"
                        type="text"
                        required
                        disabled
                        placeholder="0.00"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                    <b-button variant="primary" type="submit" class="w-100" :disabled="is_loading_add">Add</b-button>
                </b-col>
            </b-row>
        </b-form>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option } from 'element-ui'
import {axios, services, getHeader, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'
import {
  calculateInstallment, 
  calculateLoanAmount,
} from '@/assets/js/calculator.js'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import {SST_OPTIONS} from '@/assets/js/options.js'

export default {
    props:{
        proposal: Object,
        show_mortgage_application: Boolean,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    computed: {
        show: {
            get() {
                return this.show_mortgage_application;
            },
            set(newVal) {
                this.$emit('update:show_mortgage_application', newVal);
            },
        },
    },
    data() {
        return {
            is_loading_add: false,
            form:{
                bank_code: '',
                bank_name: '',
                interest: '',
                tenure_years: '',
                property_type: '',
                loan_margin: '',
                spa_price:'',
                loan_amount:'',
                installment:0,
                arrangement_fee: 0,
                arrangement_fee_any_amount: 0,
                arrangement_fee_amount: 0,
                arrangement_fee_sst: 0,
            },
            banks: [],
            SST_OPTIONS: SST_OPTIONS,
            propertyOptions: [
                {
                    value: 'Developer',
                    label: 'Developer'
                },
                {
                    value: 'Sub Sales',
                    label: 'Sub Sales'
                },
                {
                    value: 'Auction',
                    label: 'Auction'
                },
            ],
            dsr_bank: null,
        }
    },
    watch:{
        show_mortgage_application(newVal){
            if(newVal && this.banks.length === 0){
                this.getBanks()
            }
        },
        'form':{
            handler(newVal){
                if(newVal){
                    //set loan amount
                    this.form.loan_amount = calculateLoanAmount(newVal.spa_price, newVal.loan_margin)

                    //set installment
                    this.form.installment = parseFloat(calculateInstallment(newVal.loan_amount, newVal.interest, newVal.tenure_years)).toFixed(2)

                    let sst_fee = parseFloat(this.form.arrangement_fee) * parseFloat(this.form.arrangement_fee_sst) / 100
                    //set total arragement fee
                    let arrangement_fee_amount = parseFloat(this.form.arrangement_fee) + parseFloat(sst_fee)
                    if(isNaN(arrangement_fee_amount)){
                        this.form.arrangement_fee_amount = 0
                    }else{
                        this.form.arrangement_fee_amount = arrangement_fee_amount
                    }
                }
            },
            deep: true
        },
        'form.bank_code':{
            handler(newVal){
                this.setDSRBank()
            },
        },
    },
    methods: {
        resetForm(){
            this.form.bank_code = '',
            this.form.bank_name = '',
            this.form.interest = '',
            this.form.tenure_years = '',
            this.form.property_type = '',
            this.form.loan_margin = '',
            this.form.spa_price ='',
            this.form.loan_amount ='',
            this.form.installment =0,
            this.form.arrangement_fee = 0,
            this.form.arrangement_fee_any_amount = 0,
            this.form.arrangement_fee_amount = 0,
            this.form.arrangement_fee_sst = 0,
            this.dsr_bank = null,
            this.banks = []
        },
        setDSRBank(){
            this.dsr_bank = this.banks.find(bank => bank.bank_code == this.form.bank_code)
            if(this.dsr_bank ){
                this.form.interest = this.dsr_bank.bank_loan_interest_rate
                this.form.tenure_years = this.dsr_bank.bank_loan_tenure_year
            }else{
                this.form.interest = ''
                this.form.tenure_years = ''
            }
        },
        addProductApplication(){
            if(this.form.bank_code === '' || this.form.property_type === '' ){
                return
            }
            let data = {
                "pcom_psal_id": this.proposal.psal_id,
                "pcom_bank_id": null,
                "pcom_bank_name": this.dsr_bank.bank_name ?? null,
                "pcom_bank_code": this.form.bank_code,
                "pcom_loan_statue": "MORTGAGE - "+this.form.project_name,
                "pcom_credit_limit": null,
                "pcom_final_installment":  this.form.installment,
                "pcom_card_expiry": null,
                "pcom_account_number": null,
                "pcom_remark": null,
                "pcom_product_detail":{
                    "pcp_product_type":"MORTGAGE",
                    "pcp_loan_amount": this.form.loan_amount,
                    "pcp_spa_amount": this.form.spa_price,
                    "pcp_max_eligible_amount": null,
                    "pcp_interest_rate": this.form.interest,
                    "pcp_margin_finance": this.form.loan_margin,
                    "pcp_monthly_installment": this.form.installment,
                    "pcp_tenure": this.form.tenure_years,
                    "pcp_rebate_rate":null,
                    "pcp_rebate_amount":null,
                    "pcp_arragement_fee_rate": this.form.arrangement_fee,
                    "pcp_arragement_fee_rate_sst": this.form.arrangement_fee_sst,
                    "pcp_arragement_fee_amount":this.form.arrangement_fee_amount,
                    "pcp_cash_back_amount":null,
                    "pcp_client_net_amount":null,
                    "pcp_project_id":null,
                    "pcp_unit_id":null,
                    "pcp_project_name": this.form.project_name,
                    "pcp_project_image_url":null,
                    "pcp_lease_type":null,
                    "pcp_project_type": this.form.property_type,
                    "pcp_project_unit_no": this.form.unit_no,
                    "pcp_project_json":null
                }
            }

            axios.post(services.initial_proposal +'ccris-item', data, {headers:getHeader()})
                .then(res=>{
                    this.notifySuccess('<b>Proposal:</b> - Successfully Added Product.')
                    this.resetForm()
                    initialProposalEventBus.$emit('refresh-proposal-detail')
                    this.$emit('update:show_mortgage_application', false)
                })
                .catch(e=>{
                    this.errorFunction(e)
                })
        },
        getBanks(){
            axios.get(services.customer + 'customer/' + this.proposal.psal_customer_id +'/dsr.eligibilities', {headers: getHeader()})
            .then(res=>{
                    this.banks = res.data.data.bank_eligibilities
                    this.banks = this.banks.map(bank => {
                        bank.bank_name = bank.bank_code+' - '+bank.bank_name
                        return bank
                    })
                })
                .catch(e =>{
                    this.errorFunction(e)
                })
        },
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
    }
}
</script>